import { render, staticRenderFns } from "./TheComplaints.vue?vue&type=template&id=3b057165"
import script from "./TheComplaints.vue?vue&type=script&lang=js"
export * from "./TheComplaints.vue?vue&type=script&lang=js"
import style0 from "./TheComplaints.vue?vue&type=style&index=0&id=3b057165&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports